import React from 'react';

const ArrowDown = ({
  className = '',
  color = '#FFFFFF',
  height = '24px',
  width = '24px',
}) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    className={`icon ${className}`}
    fill="none"
  >
    <path
      d="M14.14,13H13V7a1,1,0,0,0-2,0v6H9.86a1,1,0,0,0-.69,1.5l2.14,3.12a.82.82,0,0,0,1.38,0l2.14-3.12A1,1,0,0,0,14.14,13Z"
      fill={color}
    />
  </svg>
);

export default ArrowDown;
